import React from 'react';
import { Navigate } from 'react-router-dom';
import { JuniorLayout } from '../layout/JuniorLayout';
import { JuniorAliveZone, JuniorAliveBackButton } from '../layout/JuniorAliveZone';
import { JuniorHubGrid } from './JuniorHubGrid';
import { ACCENT_HEX, type JuniorAccent, type JuniorHubItem } from '../../lib/juniorTheme';
import { usePlaySession } from '@/play/contexts/PlaySessionContext';
import { useJuniorAliveNav } from '../../contexts/JuniorAliveNavContext';

interface JuniorHubScreenProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  emoji: string;
  accent: JuniorAccent;
  items: JuniorHubItem[];
  backTo?: string;
  backLabel?: string;
  columns?: 1 | 2 | 3;
}

export const JuniorHubScreen: React.FC<JuniorHubScreenProps> = ({
  eyebrow,
  title,
  subtitle,
  emoji,
  accent,
  items,
  backTo = '/home',
  backLabel = 'Inicio',
  columns = 2,
}) => {
  const { hasSession } = usePlaySession();
  const { animateEntry, navigateAlive } = useJuniorAliveNav();
  const hex = ACCENT_HEX[accent];

  if (!hasSession) return <Navigate to="/" replace />;

  return (
    <JuniorLayout>
      <JuniorAliveZone accent={accent} className="mx-auto max-w-7xl px-4 sm:px-8 py-6 sm:py-10 pb-24">
        <div className={animateEntry ? 'junior-alive-block' : undefined}>
          <JuniorAliveBackButton to={backTo} label={backLabel} onNavigate={navigateAlive} />

          <header className="mb-12 sm:mb-16 flex items-start gap-4 sm:gap-6 max-w-3xl">
            <span className="text-5xl sm:text-7xl shrink-0" aria-hidden>
              {emoji}
            </span>
            <div>
              <p className="text-[11px] font-extrabold uppercase tracking-[0.22em]" style={{ color: hex }}>
                {eyebrow}
              </p>
              <h1 className="junior-display text-[clamp(2.5rem,7vw,4rem)] leading-[0.95] mt-2" style={{ color: '#2A2540' }}>
                {title}
              </h1>
              <p className="text-sm sm:text-base mt-4 leading-relaxed" style={{ color: '#6B6385' }}>
                {subtitle}
              </p>
            </div>
          </header>
        </div>

        <JuniorHubGrid items={items} columns={columns} animateEntry={animateEntry} />
      </JuniorAliveZone>
    </JuniorLayout>
  );
};

export default JuniorHubScreen;
